// ============================================================
// Wauvea WebXR — Loading Screen
// Animated loading with progress
// ============================================================

export class LoadingScreen {
  constructor() {
    this.element = document.getElementById('loading-screen');
    this.progressBar = document.getElementById('progress-bar');
    this.statusText = document.getElementById('loader-status');
  }

  update(percent, message) {
    if (this.progressBar) {
      this.progressBar.style.width = `${percent}%`;
    }
    if (this.statusText) {
      this.statusText.textContent = message;
    }
  }

  hide() {
    setTimeout(() => {
      this.element?.classList.add('hidden');
    }, 400);
  }
}
